<script>
import {Editor, Toolbar} from "@wangeditor/editor-for-vue";
import { Message } from 'element-ui';
export default {
    components: {
        Editor,
        Toolbar
    },
    props: {
        content: {
            type: String,
            default: "",
            required: true
        },
        height: {
            type: Number,
            default: 400,
        }
    },
    watch: {
          content: function(val) {
              this.html = val
          }
    },
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig: { },
            editorConfig: {
                placeholder: '请输入内容...',
                MENU_CONF: {
                    fontFamily: {
                        fontFamilyList: [
                            '黑体',
                            {name: '造字工房思乐体', value: 'MFShiLe'},
                            {name: "造字工房书见体", value: "MFShuJian"},
                            {name: "造字工房素黑体", value: "MFSuHei"},
                            {name: "造字工房悦黑体", value: "MFYueHei"},
                            {name: "造字工房展黑体", value: "MFZhanHei"},
                            {name: "造字工房致黑体", value: "MFZhiHei"},
                            {name: "造字工房智想黑体", value: "MFZhiXiangHei"},
                            {name: "造字工房知夏森林体", value: "MFZhiXiaSenLin"},
                            {name: "造字工房稚言中圆体", value: "MFZhiYanZhongYuan"},
                            {name: "造字工房知云体", value: "MFZhiYun"},
                            {name: "造字工房忠勇体", value: "MFZhongYong"},
                            {name: "造字工房庄黑体", value: "MFZhuangHei"},
                            {name: "造字工房竹黑体-粗", value: "MFZhuHei-Bold"},
                            {name: "造字工房竹黑体-细", value: "MFZhuHei-Light"},
                            {name: "造字工房竹黑体", value: "MFZhuHei-Regular"},
                            {name: "造字工房拙影体", value: "MFZhuoYing-Regular"},
                            {name: "造字工房自在体", value: "MFZiZai-Regular"},
                            {name: "造字工房品宋体", value: "MFPinSong-Regular"},
                            {name: "造字工房细黑体", value: "MFXiHei-Regular"},
                        ]
                    },
                    uploadImage: {
                        server: "news/img_upload",
                        fieldName: "image",
                        headers: {
                            authorization: [1,2].includes(Number(localStorage.getItem("role"))) ? localStorage.getItem("token") : localStorage.getItem("sToken"),
                        },
                        onFailed(file, res) {
                            Message.error(res.msg)
                        }
                    },
                    uploadVideo: {
                        server: "news/video_upload",
                        fieldName: "video",
                        maxFileSize: 500 * 1024 *1024,
                        headers: {
                            authorization: [1,2].includes(Number(localStorage.getItem("role"))) ? localStorage.getItem("token") : localStorage.getItem("sToken"),
                        },
                        onFailed(file, res) {
                            Message.error(res.msg)
                        }
                    }
                }
            },
            mode: 'default', // or 'simple'
        }
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        onChange(editor) {
            this.$emit("change", editor.getHtml())
        },
        setHtmlValue(content) {
            this.html = content; // 手动设置html值
        }
    },
    mounted() {
        setTimeout(() => {
            this.html = this.content
        }, 500)
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
}

</script>

<template>
    <div style="border: 1px solid #ccc;">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="overflow-y: hidden;"
            :style="{height: `${height}px`}"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
            @onChange="onChange"
        />
    </div>

</template>

<style scoped lang="scss">

</style>
